import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import {
  MatSelect,
  MatSelectChange,
  MatSelectModule,
} from '@angular/material/select';
import { SelectDisplayMode } from '../../../core/types/enums';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class SelectComponent {
  @ViewChild('select') select: MatSelect;
  @Output() selectionChange = new EventEmitter<any>();
  @Input() options: any[];
  @Input() placeholder: string;
  @Input() label: string;
  @Input() labelField: string = 'label';
  @Input() valueField: string = 'value';
  @Input() iconField: string = 'icon';
  @Input() multiple = false;
  @Input() control: FormControl;
  @Input() hasBorder = false;
  @Input() displayErrorMessage = true;
  @Input() errorMessages: { [key: string]: string } = {};
  @Input() displayMode: SelectDisplayMode = 'TEXT';
  @Input() readonly = false;
  @Input() optionIsDisabled: Function = () => false;

  constructor() {}

  get selectInludesIcon() {
    return this.displayMode === 'ICON_WITH_TEXT' || this.displayMode === 'ICON';
  }

  onSelectionChange = (event: MatSelectChange) => {
    this.selectionChange.emit(event.value);
    this.select.close();
    event.source.close();
  };

  isInputInvalid() {
    return this.control.invalid && (this.control.dirty || this.control.touched);
  }

  getErrorMessage(): string | undefined {
    const errors = this.control.errors;
    if (!errors) return undefined;
    const errorKey = Object.keys(errors)[0];
    return this.errorMessages[errorKey];
  }

  getSelectedOptionField(field: string): string {
    const selectedOption = this.options.find(
      option => option[this.valueField] === this.control.value
    );
    switch (field) {
      case 'label':
        return selectedOption ? selectedOption[this.labelField] : '';
      case 'icon':
        return selectedOption ? selectedOption[this.iconField] : '';
      default:
        return '';
    }
  }

  _optionIsDisabled = (value: any) => {
    return this.optionIsDisabled(value);
  };
}
